import { defineMessages } from "react-intl";

import {
	iggMessages,
	validator
} from "lib/build/forms/htx/microbiological-procedures/varicellaSerology";

import { FieldData, FieldsetData } from "src/features/forms";
import { genericErrorMessages } from "src/messages/generic";
import { LeafNode } from "src/modules/shared/form-explorer";

const messages = defineMessages({
	varicellaSerology: {
		id: "form.varicella_serology",
		defaultMessage: "Varicella"
	},
	igg: {
		id: "form.varicella_serology.igg",
		defaultMessage: "IgG"
	}
});

const fields: { [key: string]: FieldData } = {
	igg: {
		type: "field",
		path: ["igg"],
		label: messages.igg,
		errorMessages: genericErrorMessages,
		input: { type: "button-group", props: { labels: iggMessages } }
	}
};

const fieldset: FieldsetData = {
	rows: [{ columns: [{ width: 12, field: fields.igg }] }]
};

export const node: LeafNode = {
	id: "varicellaSerology",
	value: {
		title: messages.varicellaSerology,
		validator,
		fieldset,
		isImportant: true
	}
};
